import { DEFAULT_TITLE_CASED_KEYS } from 'common/constants';
import get from 'lodash/get';
import React, { useCallback } from 'react';
import { PORTAL_PATHS } from 'routes/constants';
import { history } from 'routes/history';
import titleize from 'titleize';

import {
  ListItemDiv,
  PermitDataCell,
  PermitGridRow,
  PermitViewButton,
} from '../styles';

function RowButton({ onButtonClick }) {
  return (
    <PermitDataCell>
      <PermitViewButton onClick={onButtonClick}>View</PermitViewButton>
    </PermitDataCell>
  );
}

function DataDisplay({ fieldKey, permit, titleCased }) {
  const fn = titleCased ? titleize : (e) => e;
  return <PermitDataCell>{fn(get(permit, fieldKey))}</PermitDataCell>;
}

function Cell(props) {
  if (props.fieldKey === 'rowAction') return <RowButton {...props} />;
  return (
    <DataDisplay
      titleCased={DEFAULT_TITLE_CASED_KEYS.includes(props.fieldKey)}
      {...props}
    />
  );
}

export function PermitRow(props) {
  const { index, layout, permit } = props;

  const handlePermitViewClick = useCallback(() => {
    history.push(
      `${PORTAL_PATHS.dashboardSinglePermit}/${permit.applicationNumber}`,
    );
  }, [permit.applicationNumber]);

  return (
    <ListItemDiv index={index}>
      <PermitGridRow layout={layout}>
        {layout.map(({ key }) => (
          <Cell
            key={key}
            fieldKey={key}
            permit={permit}
            onButtonClick={handlePermitViewClick}
          />
        ))}
      </PermitGridRow>
    </ListItemDiv>
  );
}
